<template>
  <div class="table-container">
    <!-- 儿童信息行 -->
    <div class="child-info">
      <div class="info-item">
        <span class="label">儿童名称：</span>
        <span v-if="loading" class="value loading-value">
          <i class="el-icon-loading"></i> 加载中...
        </span>
        <span v-else class="value">{{ childName }}</span>
      </div>
      <div class="info-item">
        <span class="label">所在机构：</span>
        <span v-if="loading" class="value loading-value">
          <i class="el-icon-loading"></i> 加载中...
        </span>
        <span v-else class="value">{{ organization }}</span>
      </div>
      <div class="info-item year-selector">
        <span class="label">统计年份：</span>
        <el-select v-model="selectedYear" @change="handleYearChange" placeholder="请选择年份" size="small">
          <el-option
            v-for="year in yearList"
            :key="year"
            :label="year + '年'"
            :value="year">
          </el-option>
        </el-select>
      </div>
      <div class="export-btn-container">
        <el-button type="primary" @click="exportToExcel" size="small">
          <i class="el-icon-download"></i> 导出Excel
        </el-button>
      </div>
    </div>

    <!-- 加载状态 -->
    <div v-if="loading" class="loading">
      数据加载中...
    </div>

    <!-- 错误信息 -->
    <div v-else-if="error" class="error">
      {{ error }}
    </div>

    <!-- 表格 -->
    <div v-else class="table-wrapper">
      <table class="calendar-table">
        <!-- 表头 -->
        <thead>
          <tr>
            <th class="month-header">月份/日期</th>
            <th v-for="(day, i) in heng" :key="i" class="day-header">{{ day }}</th>
            <th class="total-header">每月合计</th>
          </tr>
        </thead>
        <!-- 表格主体 -->
        <tbody>
          <tr v-for="(month, i) in zong" :key="i" class="month-row">
            <td class="month-cell">{{ month }}月</td>
            <td v-for="(day, j) in heng" :key="j" class="day-cell">
              <!-- 显示打卡数据 -->
              <div v-if="getDayData(month, day)" class="kq-data">
                <!-- 如果是课程补签，显示课程补签 -->
                <div v-if="getDayData(month, day).dcs_class === '课程补签'" class="kq-buqian">
                  课程补签
                </div>
                <!-- 否则显示正常打卡数据 -->
                <div v-else>
                  <div :class="['kq-duration', getDurationColor(getDayData(month, day))]">{{ getDuration(getDayData(month, day)) }}小时</div>
                  <div class="kq-time">{{ getDayData(month, day).start_time }} - {{ getDayData(month, day).end_time }}</div>
                </div>
              </div>
            </td>
            <!-- 每月合计列 -->
            <td class="total-cell">
              <div class="total-item">
                <span class="total-label">总天数：</span>
                <span class="total-value">{{ getMonthTotalDays(month) }}</span>
              </div>
              <div class="total-item">
                <span class="total-label">合格天数：</span>
                <span class="total-value green">{{ getMonthQualifiedDays(month) }}</span>
              </div>
              <div class="total-item">
                <span class="total-label">总时长：</span>
                <span class="total-value">{{ getMonthTotalHours(month) }}小时</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
// 导入xlsx库用于导出Excel
import * as XLSX from 'xlsx';

export default {
  name: "onestukq",
  data() {
    return {
      heng: [], // 横坐标：1-31天
      zong: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], // 纵坐标：1-12月
      childName: "张三", // 儿童名称
      organization: "儿康管家机构", // 所在机构
      yearList: [], // 年份列表，2023-今年
      selectedYear: new Date().getFullYear(), // 选中的年份，默认为今年
      loading: false, // 加载状态
      error: '', // 错误信息
      kqData: {}, // 打卡数据，格式：{ 'month-day': { start_time, end_time } }
      // 请求配置
      apiUrl: 'https://api.heiban.fun/teacher_y/org_kq_one',
      apiParams: {
        year: new Date().getFullYear(),
        stu_id: 365,
        org_id: 3
      },
      apiHeaders: {
        teatoken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwaG9uZSI6IjEzMjkwMTY4Mjk1MTIzIiwiaWF0IjoxNzU5ODA3ODcxfQ.K12PctcV-AklRZMKkpR0zLuklwwRXConoqKxJLcgu6M'
      }
    };
  },
  created() {
    let token = window.localStorage.getItem("info");
			token = JSON.parse(token);
			if (token.uid) {

			} else {
				this.$router("/login");
			}
      this.apiHeaders.teatoken = window.localStorage.getItem("tea_token");
    // 生成1-31天
    for (let i = 1; i <= 31; i++) {
      this.heng.push(i);
    }
    
    // 生成年份列表，2023-今年
    this.generateYearList();
    
    // 处理query参数
    this.handleQueryParams();
    
    // 调用获取数据函数
    this.getdata();
  },
  watch: {
    // 监听路由变化，处理新的query参数
    $route: {
      handler: function() {
        this.handleQueryParams();
        this.getdata();
      },
      immediate: false
    }
  },
  methods: {
    // 生成年份列表，2023-今年
    generateYearList() {
      const currentYear = new Date().getFullYear();
      const startYear = 2023;
      this.yearList = [];
      
      for (let year = startYear; year <= currentYear; year++) {
        this.yearList.push(year);
      }
      
      // 倒序排列，今年在前
      this.yearList.reverse();
    },
    
    // 处理路由query参数
    handleQueryParams() {
      // 从路由query中获取参数
      const { stu_id, year } = this.$route.query;
      
      // 如果有stu_id参数，更新apiParams
      if (stu_id) {
        this.apiParams.stu_id = parseInt(stu_id);
      }
      
      // 如果有year参数，更新selectedYear和apiParams
      if (year) {
        const yearNum = parseInt(year);
        this.selectedYear = yearNum;
        this.apiParams.year = yearNum;
      }
    },
    
    // 处理年份变化
    handleYearChange() {
      // 更新请求参数中的年份
      this.apiParams.year = this.selectedYear;
      // 清空原有数据
      this.kqData = {};
      // 重新请求数据
      this.getdata();
    },
    
    // 获取打卡数据
    async getdata() {
      this.loading = true;
      this.error = '';
      try {
        const response = await this.$axios({
          url: this.apiUrl,
          method: 'get',
          params: this.apiParams,
          headers: this.apiHeaders
        });
        console.log(response);
        // 处理成功响应
          // 假设数据格式为：{ '2025-01-01': { start_time: '08:00', end_time: '17:00' } }
          this.processKqData(response.data.shuju);
          // 更新儿童信息（接口可能不返回stu，需判空）
          if (response.data.stu) {
            this.childName = response.data.stu.stu_name;
            this.organization = response.data.stu.org_name;
          }
          
        
      } catch (err) {
        this.error = err.message || '网络错误，请稍后重试';
        console.error('获取打卡数据失败:', err);
      } finally {
        this.loading = false;
      }
    },
    
    // 处理打卡数据，转换为便于表格展示的格式
    processKqData(data) {
      const processedData = {};
      
      // 根据实际返回数据格式处理：数组格式，每条记录包含riqi_ke、start_time、end_time
      if (Array.isArray(data)) {
        data.forEach(item => {
          // 从riqi_ke字段提取日期，格式为"2025-01-01"
          const dateParts = item.riqi_ke.split('-');
          if (dateParts.length === 3) {
            const year = parseInt(dateParts[0]);
            const month = parseInt(dateParts[1]);
            const day = parseInt(dateParts[2]);
            const key = `${month}-${day}`;
            
            // 如果end_time为空或null，就让它等于start_time
            const actualEndTime = item.end_time || item.start_time;
            
            // 格式化时间，只显示时分部分
            const formattedStartTime = this.formatTime(item.start_time);
            const formattedEndTime = this.formatTime(actualEndTime);
            
            processedData[key] = {
              start_time: formattedStartTime,
              end_time: formattedEndTime,
              original_start: item.start_time, // 保存原始时间用于计算时长
              original_end: actualEndTime, // 使用处理后的结束时间
              dcs_class: item.dcs_class // 保存打卡类型
            };
          }
        });
      }
      
      this.kqData = processedData;
    },
    
    // 格式化时间，将ISO格式转换为HH:MM
    formatTime(isoTime) {
      if (!isoTime) return '';
      
      const date = new Date(isoTime);
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${hours}:${minutes}`;
    },
    
    // 根据月份和日期获取当天的打卡数据
    getDayData(month, day) {
      const key = `${month}-${day}`;
      return this.kqData[key] || null;
    },
    
    // 计算时长，返回小数形式的小时数，保留两位小数
    getDuration(kqItem) {
      if (!kqItem || !kqItem.original_start || !kqItem.original_end) {
        return '';
      }
      
      // 如果是课程补签，时长为0
      if (kqItem.dcs_class === '课程补签') {
        return '0.00';
      }
      
      const start = new Date(kqItem.original_start);
      const end = new Date(kqItem.original_end);
      const durationMs = end - start;
      
      // 计算总小时数，保留两位小数
      const totalHours = durationMs / (1000 * 60 * 60);
      return totalHours.toFixed(2);
    },
    
    // 根据时长返回颜色类名
    getDurationColor(kqItem) {
      if (!kqItem || !kqItem.original_start || !kqItem.original_end) {
        return '';
      }
      
      // 如果是课程补签，返回特殊颜色
      if (kqItem.dcs_class === '课程补签') {
        return 'duration-blue';
      }
      
      const start = new Date(kqItem.original_start);
      const end = new Date(kqItem.original_end);
      const durationMs = end - start;
      const totalHours = durationMs / (1000 * 60 * 60);
      
      // 大于2.9小时为绿色，小于1.5小时为红色，其他为黄色
      if (totalHours > 2.9) {
        return 'duration-green';
      } else if (totalHours < 1.5) {
        return 'duration-red';
      } else {
        return 'duration-yellow';
      }
    },
    
    // 统计每月打卡总天数
    getMonthTotalDays(month) {
      let count = 0;
      // 遍历当月的所有天数（1-31）
      for (let day = 1; day <= 31; day++) {
        const key = `${month}-${day}`;
        if (this.kqData[key]) {
          count++;
        }
      }
      return count;
    },
    
    // 统计每月合格天数（绿色天数，时长>2.9小时，排除课程补签）
    getMonthQualifiedDays(month) {
      let count = 0;
      // 遍历当月的所有天数（1-31）
      for (let day = 1; day <= 31; day++) {
        const key = `${month}-${day}`;
        const dayData = this.kqData[key];
        if (dayData && dayData.original_start && dayData.original_end) {
          // 课程补签不计入合格天数
          if (dayData.dcs_class === '课程补签') {
            continue;
          }
          
          const start = new Date(dayData.original_start);
          const end = new Date(dayData.original_end);
          const durationMs = end - start;
          const totalHours = durationMs / (1000 * 60 * 60);
          if (totalHours > 2.9) {
            count++;
          }
        }
      }
      return count;
    },
    
    // 统计每月总打卡时长，返回小数形式，保留两位小数，课程补签不计入时长
    getMonthTotalHours(month) {
      let totalHours = 0;
      // 遍历当月的所有天数（1-31）
      for (let day = 1; day <= 31; day++) {
        const key = `${month}-${day}`;
        const dayData = this.kqData[key];
        if (dayData && dayData.original_start && dayData.original_end) {
          // 课程补签不计入时长
          if (dayData.dcs_class === '课程补签') {
            continue;
          }
          
          const start = new Date(dayData.original_start);
          const end = new Date(dayData.original_end);
          const durationMs = end - start;
          const dayHours = durationMs / (1000 * 60 * 60);
          totalHours += dayHours;
        }
      }
      return totalHours.toFixed(2);
    },
    
    // 导出表格到Excel
    exportToExcel() {
      // 创建Excel工作簿
      const wb = XLSX.utils.book_new();
      
      // 创建表头
      const headers = ['月份/日期'];
      // 添加1-31天的表头
      for (let i = 1; i <= 31; i++) {
        headers.push(i + '日');
      }
      // 添加合计列
      headers.push('总天数', '合格天数', '总时长(小时)');
      
      // 创建数据行
      const rows = [];
      rows.push(headers);
      
      // 添加每个月的数据
      this.zong.forEach(month => {
        const row = [`${month}月`];
        
        // 添加1-31天的数据
        for (let day = 1; day <= 31; day++) {
          const dayData = this.getDayData(month, day);
          if (dayData) {
            // 显示时长
            row.push(this.getDuration(dayData) + '小时');
          } else {
            row.push('');
          }
        }
        
        // 添加合计数据
        row.push(this.getMonthTotalDays(month));
        row.push(this.getMonthQualifiedDays(month));
        row.push(this.getMonthTotalHours(month) + '小时');
        
        rows.push(row);
      });
      
      // 创建工作表
      const ws = XLSX.utils.aoa_to_sheet(rows);
      
      // 设置列宽
      const colWidths = [
        { wch: 12 }, // 月份/日期列
      ];
      // 1-31天列，每列宽10
      for (let i = 0; i < 31; i++) {
        colWidths.push({ wch: 10 });
      }
      // 合计列
      colWidths.push({ wch: 8 }, { wch: 8 }, { wch: 12 });
      ws['!cols'] = colWidths;
      
      // 添加工作表到工作簿
      XLSX.utils.book_append_sheet(wb, ws, '打卡记录');
      
      // 生成Excel文件名
      const fileName = `${this.childName}_${this.selectedYear}年打卡记录.xlsx`;
      
      // 导出文件
      XLSX.writeFile(wb, fileName);
    }
  }
};
</script>

<style scoped>
.table-container {
  padding: 1%; /* 使用百分比内边距 */
  background-color: #f5f7fa;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  width: 100%; /* 使用百分比宽度 */
  height: 100vh; /* 占满整个视口高度 */
  box-sizing: border-box; /* 确保内边距和边框不影响总宽度 */
  overflow: hidden; /* 隐藏溢出内容 */
}

/* 儿童信息样式 */
.child-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.info-item {
  margin-right: 40px;
  font-size: 18px; /* 增大字体大小，让儿童信息更醒目 */
}

.label {
  font-weight: bold;
  color: #606266;
  margin-right: 8px;
}

.value {
  color: #303133;
  font-weight: bold; /* 加粗显示，让内容更突出 */
}

/* 加载中样式 */
.loading-value {
  color: #909399;
  font-style: italic;
  display: flex;
  align-items: center;
}

.loading-value .el-icon-loading {
  margin-right: 4px;
  animation: rotate 1s linear infinite;
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* 年份选择器样式 */
.year-selector {
  display: flex;
  align-items: center;
}

.year-selector .el-select {
  width: 120px;
}

/* 导出按钮容器 */
.export-btn-container {
  margin-left: 20px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .child-info {
    flex-wrap: wrap;
  }
  
  .year-selector {
    margin-top: 10px;
    width: 100%;
    justify-content: flex-start;
  }
  
  .export-btn-container {
    margin-left: 0;
    margin-top: 10px;
    width: 100%;
    text-align: center;
  }
}

/* 加载状态 */
.loading {
  text-align: center;
  padding: 40px;
  color: #909399;
  font-size: 16px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

/* 错误信息 */
.error {
  text-align: center;
  padding: 40px;
  color: #f56c6c;
  font-size: 16px;
  background-color: #fff1f0;
  border: 1px solid #fbc4ab;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

/* 表格容器 */
.table-wrapper {
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  width: 100%;
  height: calc(100% - 120px); /* 减去顶部信息栏的高度，确保表格占满剩余空间 */
  overflow: auto; /* 允许水平和垂直滚动 */
}

/* 表格样式 */
.calendar-table {
  width: auto;
  min-width: 100%;
  border-collapse: collapse;
  text-align: center;
  table-layout: auto; /* 自动表格布局，让内容决定列宽 */
  font-size: 14px; /* 使用固定字体大小，确保可读性 */
}

/* 表头样式 */
.calendar-table th {
  background-color: #ecf5ff;
  color: #409eff;
  font-weight: bold;
  padding: 10px 5px; /* 使用固定内边距，确保足够空间 */
  border: 1px solid #e4e7ed;
  white-space: nowrap;
  position: sticky;
  top: 0;
  z-index: 10;
}

.month-header {
  width: 100px; /* 固定月份列宽度 */
  background-color: #f0f9eb;
  color: #67c23a;
  position: sticky;
  left: 0;
  z-index: 5;
}

.day-header {
  width: 80px; /* 固定天数列宽度 */
  min-width: 80px; /* 确保最小宽度 */
}

/* 合计列表头样式 */
.total-header {
  width: 150px; /* 固定合计列宽度 */
  background-color: #ecf5ff;
  color: #409eff;
  font-weight: bold;
}

/* 表格行样式 */
.month-row {
  height: 80px; /* 固定行高，确保内容有足够空间 */
  min-height: 80px; /* 确保最小行高 */
}

.month-row:nth-child(even) {
  background-color: #fafafa;
}

.month-row:hover {
  background-color: #f5f7fa;
}

/* 单元格样式 */
.calendar-table td {
  padding: 8px 5px; /* 固定内边距，确保内容有足够空间 */
  border: 1px solid #e4e7ed;
  vertical-align: middle;
  white-space: normal; /* 允许内容换行 */
  word-break: break-all; /* 允许单词换行 */
}

.month-cell {
  font-weight: bold;
  background-color: #f0f9eb;
  color: #67c23a;
  width: 100px; /* 固定月份单元格宽度 */
  position: sticky;
  left: 0;
  z-index: 5;
}

.day-cell {
  width: 80px; /* 固定天数列宽度 */
  min-width: 80px; /* 确保最小宽度 */
  cursor: pointer;
  transition: all 0.3s ease;
  vertical-align: top;
  height: 80px;
}

.day-cell:hover {
  background-color: #ecf5ff;
  border-color: #d9ecff;
}

/* 合计列单元格样式 */
.total-cell {
  width: 150px; /* 固定合计列宽度 */
  background-color: #fafafa;
  border-left: 2px solid #e4e7ed;
  padding: 8px 5px; /* 固定内边距 */
  vertical-align: middle;
}

/* 合计项样式 */
.total-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px; /* 固定间距 */
  font-size: 12px; /* 固定字体大小 */
  line-height: 1.4;
}

.total-item:last-child {
  margin-bottom: 0;
}

/* 合计标签样式 */
.total-label {
  color: #606266;
  font-weight: normal;
  flex: 1;
  text-align: left;
  padding-right: 0.5%; /* 使用百分比内边距 */
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 合计值样式 */
.total-value {
  color: #303133;
  font-weight: bold;
  flex-shrink: 0;
}

/* 绿色合格天数样式 */
.total-value.green {
  color: #67c23a;
}

/* 打卡数据样式 */
.kq-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 5px;
  box-sizing: border-box;
}

/* 时长样式（主要显示） */
.kq-duration {
  font-size: 16px; /* 增大字体大小，让时长更醒目 */
  font-weight: bold;
  padding: 3px 8px; /* 恢复原内边距 */
  border-radius: 4px;
  white-space: nowrap;
  margin-bottom: 3px;
  line-height: 1.4;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 时长颜色样式 */
.duration-green {
  color: #67c23a;
  background-color: #f0f9eb;
  border: 1px solid #c2e7b0;
}

.duration-yellow {
  color: #e6a23c;
  background-color: #fdf6ec;
  border: 1px solid #fce5cd;
}

.duration-red {
  color: #f56c6c;
  background-color: #fef0f0;
  border: 1px solid #fbc4ab;
}

/* 课程补签样式 */
.duration-blue {
  color: #409eff;
  background-color: #ecf5ff;
  border: 1px solid #d9ecff;
}

/* 课程补签显示样式 */
.kq-buqian {
  font-size: 12px;
  color: #409eff;
  font-weight: bold;
  background-color: #ecf5ff;
  border: 1px solid #d9ecff;
  padding: 3px 8px;
  border-radius: 4px;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 时间范围样式（辅助显示） */
.kq-time {
  font-size: 11px;
  color: #909399;
  line-height: 1.4;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .child-info {
    flex-direction: column;
  }
  
  .info-item {
    margin-right: 0;
    margin-bottom: 10px;
  }
  
  .calendar-table {
    font-size: 12px;
  }
  
  .calendar-table th,
  .calendar-table td {
    padding: 6px 4px;
  }
  
  .day-header,
  .day-cell {
    width: 60px;
  }
  
  .month-row {
    height: 60px;
  }
  
  .kq-time {
    font-size: 10px;
  }
  
  .kq-duration {
    font-size: 9px;
    padding: 1px 4px;
  }
}
</style>